// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')
require('./shared_functions')
require('../site_scripts/mtc_carz_mobile_menu')
require('../carz/modules/carz-range-search')
require('../global/read-more')

require('../../styles/entry/carz-range-search.less')
